import { Col, Row } from "antd";
import styles from "./ProductArticleDetails.module.scss";
import { Link } from "react-router-dom";

const ProductArticleDetails = ({ product, selectedVariant }) => {
    return (
        <div className={styles.productArticleDetails}>
            <Row>
                <Col span={12}>
                    <div>Brand</div>
                    {/* <div>Flavour</div>
                    <div>Weight</div> */}
                    <div>Size</div>
                    <div>Number of Items</div>
                </Col>
                <Col span={12}>
                    <div style={{ textDecoration: "underline" }}>
                        {" "}
                        <Link to={`/brand/${product.brand.slug}_${product.brand.id}`}>{product.brand.name}</Link>
                    </div>
                    <div>{selectedVariant.value}</div>
                    {/* <div>{selectedVariant.stock}</div> */}
                    <div>1</div>
                </Col>
            </Row>

            <div className={styles.about_this_product}>
                <div style={{ fontWeight: "bold" }}>About this product</div>
                <div>
                    {product.description ? (
                        <div dangerouslySetInnerHTML={{ __html: product.description }} />
                    ) : (
                        <div>No Description Available</div>
                    )}
                </div>
            </div>

            {/* <div className={styles.additional_info}>
                <div style={{ textDecoration: "underline", fontWeight: "bold" }}> See Additional product details </div>
            </div> */}
            {/* <div className={styles.reportFalse} onClick={reportFalse}>
                <img src={"https://desi-fresh.b-cdn.net/components_static/ProductDescription/email.svg"} height={15} alt="report" />
                <div>Report false or incorrect product information </div>
            </div> */}
        </div>
    );
};

export default ProductArticleDetails;
